import React from 'react';
import PropTypes from 'prop-types';

export const CardContainer = ({ children = null }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 370 218"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="100%" height="218" rx="12" fill="#E9521D" />
    <rect width="100%" height="218" rx="12" fill="url(#paint0_diamond)" fillOpacity="0.1" />
    {children}
    <defs>
      <radialGradient
        id="paint0_diamond"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(185 109) rotate(90) scale(109 185)">
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);
CardContainer.propTypes = {
  children: PropTypes.node,
};
export default CardContainer;
